import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simular verificación de autenticación
    const savedUser = localStorage.getItem('b2b_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // Simular autenticación con avatar
    const mockUsers = [
      { id: 1, email: 'admin@empresa.com', password: 'admin123', role: 'admin', name: 'Administrador Principal', avatar: 'https://randomuser.me/api/portraits/men/1.jpg' },
      { id: 2, email: 'agencia@marketing.com', password: 'agencia123', role: 'agency', name: 'Agencia Marketing Pro', avatar: 'https://randomuser.me/api/portraits/women/2.jpg' },
      { id: 3, email: 'distribuidor@ventas.com', password: 'dist123', role: 'agency', name: 'Distribuidor Elite', avatar: 'https://randomuser.me/api/portraits/men/3.jpg' }
    ];

    const foundUser = mockUsers.find(u => u.email === email && u.password === password);
    
    if (foundUser) {
      const userData = { ...foundUser };
      delete userData.password;
      setUser(userData);
      localStorage.setItem('b2b_user', JSON.stringify(userData));
      return { success: true };
    }
    
    return { success: false, error: 'Credenciales inválidas' };
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('b2b_user');
  };

  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin'
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};